import { render, staticRenderFns } from "./DeptPaperInfo.vue?vue&type=template&id=e41611fe&scoped=true"
import script from "./DeptPaperInfo.vue?vue&type=script&lang=js"
export * from "./DeptPaperInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptPaperInfo.vue?vue&type=style&index=0&id=e41611fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41611fe",
  null
  
)

export default component.exports